import { Clickable } from 'src/shared/design-system/Utilities';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const PanelWrapper = styled.div<{ emphasize?: boolean; noOverflow?: boolean }>`
  border-radius: ${Border.Radius.S};
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
  ${ifProp(
    'noOverflow',
    css`
      overflow: hidden;
    `
  )}
  ${ifProp(
    'emphasize',
    css`
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
    `,
    css`
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
    `
  )}
`;

export const PanelContainer = styled(PanelWrapper)<{ fullHeight?: boolean }>`
  background: ${Colors.WHITE};
  width: 100%;

  ${ifProp(
    'fullHeight',
    css`
      height: 100%;
    `
  )}
`;

export const HeaderIconContainer = styled.div`
  margin-right: ${Spacing.SINGLE};

  ${Mixins.Flex.center()}
  & svg {
    height: ${Spacing.SINGLE};
    width: ${Spacing.SINGLE};
  }
`;

export const PanelHeaderWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const PanelHeader = styled.div<{ padded?: boolean }>`
  display: flex;
  flex: 1;
  font-weight: ${Font.Weight.SEMI_BOLD};
  padding: ${ifProp('padded', css`calc(${Spacing.SINGLE} - ${Spacing.EIGHTH}) ${Spacing.SINGLE} 0`, 0)};
  ${Font.bySize(Font.Size.L)}

  &:not(:only-child) {
    padding-bottom: 0;
  }
`;

export const PanelSubHeader = styled.div<{ padded?: boolean }>`
  color: ${Colors.GRAY_DARK_10};
  font-weight: ${Font.Weight.NORMAL};
  padding: ${ifProp('padded', css`0 ${Spacing.SINGLE} ${Spacing.HALF}`, 0)};
  text-align: left;
  ${Font.bySize(Font.Size.XS)}
`;

export const PanelHeaderContainer = styled(Clickable)<{ darkBackground?: boolean; to?: string }>`
  display: flex;
  padding: 0;

  ${ifProp(
    'to',
    css`
      cursor: pointer;
    `
  )}

  ${ifProp(
    'darkBackground',
    css`
      color: ${Colors.WHITE};

      & ${HeaderIconContainer} {
        opacity: 0.5;
      }
    `,
    css`
      & ${HeaderIconContainer} {
        color: ${Colors.GRAY_DARK_10};
      }
    `
  )}
  &:hover ${HeaderIconContainer} {
    color: ${Colors.GRAY};
    ${ifProp(
      'darkBackground',
      css`
        color: ${Colors.WHITE};
        opacity: 0.75;
      `
    )}
  }
`;

export const Contents = styled.div<{ noContentPadding?: boolean }>`
  ${ifProp(
    'noContentPadding',
    css`
      padding: 0;
    `,
    css`
      padding: ${Spacing.SINGLE};
    `
  )}
`;

export const PanelTitle = styled.div<{ hasSubtitle?: boolean }>`
  align-items: left;
  display: flex;
  flex-direction: column;
  font-size: 28px;
  font-family: ${Font.Family.SANS};
  justify-content: center;
  color: ${Colors.GRAY_DARK_20};
  font-weight: 300;
  min-height: ${ifProp('hasSubtitle', Spacing.QUADRUPLE, Spacing.DOUBLE)};
  margin-bottom: -${Spacing.SINGLE} !important;

  ${Mixins.Media.maxWidthSmall(css`
    margin: 0 ${Spacing.SINGLE};
  `)}
`;

export const PanelSubTitle = styled.div`
  font-size: ${Font.Size.XXS};
  color: ${Colors.GRAY_DARK_20};
  font-weight: 300;
`;
